import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

export const BFGTheme = definePreset(Lara, {
    primitive: {
        sky: {
            50: '#bae6f7',
            100: '#a8dff5',
            200: '#83d2f1',
            300: '#5ec4ed',
            400: '#3ab7e9',
            500: '#19a8e1',
            600: '#158dbc',
            700: '#117198',
            800: '#0d5673',
            900: '#093a4e',
            950: '#072d3c',
        }
    },
    semantic: {
        primary: {
            50: '#78cdff',
            100: '#63c6ff',
            200: '#3ab7ff',
            300: '#12a8ff',
            400: '#0093e8',
            500: '#0079BF',
            600: '#005f96',
            700: '#00456d',
            800: '#002b45',
            900: '#00121c',
            950: '#000507',
        },
//         success: {
//     200: '#07A279',
//     300: '#07A279',
//     400: '#07A279',
//     500: '#07A279',
//     600: '#2d7a5c'
//   }
        // info: {
        //     50: '#2cb2ff',
        //     100: '#17aaff',
        //     200: '#0097ed',
        //     300: '#007dc5',
        //     400: '#00639c',
        //     500: '#004973',
        //     600: '#002f4a',
        //     700: '#001521',
        //     800: '#000000',
        //     900: '#000000',
        //     950: '#000000',
        // }
    },
});
